<div class="flex-center-between">
  <div class="gap-100" [ngClass]="msg ? 'flex' : 'flex-center'">
    @if (icon) {
      <app-st-icon [style.color]="iconColor" [bold]="true" [name]="icon"></app-st-icon>
    }
    <div style="padding: 3.5px 0" class="flex flex-column gap-100">
      <span class="text-label-14 text-semibold">{{content}}</span>
      @if (msg) {
        <span class="text-label-12" style="color: white; white-space: pre-line;">{{msg}}</span>
      }
    </div>
  </div>

  <div class="flex gap-050" style="align-self: flex-start;">
    @if (showUndo) {
      <button nz-button nzSize="large" nzType="text" nzShape="circle">
        <app-st-icon [bold]="true" name="undo"></app-st-icon>
      </button>
    }
    <button nz-button nzSize="large" nzType="text" nzShape="circle" (click)="close()">
      <app-st-icon [bold]="true" name="close"></app-st-icon>
    </button>
  </div>
</div>
